// Module
var code = "<thead> <tr> <th class=\"grid-key\">Key</th> <th class=\"grid-field\">Field</th> <th class=\"grid-alias\">Alias</th> <th class=\"grid-type\">Type</th> <th class=\"grid-action\"></th> </tr> </thead> <tbody></tbody> ";
// Exports
export default code;